import { Address } from '@app/domain/model/Address';

export function addressSignature(address?: Nullable<Address>): string {
    if (address == null) {
        return '';
    }

    return [
        (address.country ?? '').toLowerCase(),
        address.street ?? '',
        address.houseNumber ?? '',
        address.apartmentNumber ?? '',
        address.city ?? '',
        address.postalCode ?? '',
        address.municipality ?? '',
    ].join('|');
}
